module.exports = {
      id: "icon-episode-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-episode",
      toString: function () {
        return this.url;
      }
    }